module.exports = __webpack_public_path__ + "c2a5eed6d2e7bb0514f42023202065e4.jpg";